import Axios from "axios";
import { protectedResources } from "../authConfig";

//const getAccessToken  = sessionStorage.getItem('AccessToken');
const URL = protectedResources.apiHRMobile.endpoint;
let tokenKey;
// eslint-disable-next-line no-undef
if (sessionStorage.getItem("AccessToken") !== null) {
  tokenKey = JSON.parse(sessionStorage.getItem("AccessToken")).value;
  // eslint-disable-next-line no-undef
  localStorage.setItem("AccessTokens", tokenKey);
}
const config = {
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${tokenKey}`,
  },
};


export async function GetMenuItems() {
  try {
    const URLOrder =
    URL + "/MemuService";
    const response = await Axios.get(URLOrder, config);
    // eslint-disable-next-line no-undef
    localStorage.setItem("menuItems", JSON.stringify(response.data));
    return await response.data;
  } catch (error) {
    console.error(error);
    if (error?.response?.status == 401) {
      // eslint-disable-next-line no-undef
      localStorage.removeItem("menuItems");
      // eslint-disable-next-line no-undef
      sessionStorage.removeItem("menuItems");
    }
    throw new Error(error);
  }
}

export async function updateOrder(data) {
  try {
    const URLOrder =
    URL + "/MemuService/updateOrder";
    console.log(URLOrder);
    const response = await Axios.put(URLOrder, data, config);
    return await response.data;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

export async function updateStatus(id, obj) {
  try {
    const URLOrder =
      URL + "/MemuService/updateStatus/" + id;
    console.log(URLOrder);
    const response = await Axios.put(URLOrder, obj, config);
    return await response.data;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

export async function createItemMenu(data) {
  try {
    const URLOrder = URL + "/MemuService";
    console.log(URLOrder);
    const response = await Axios.post(URLOrder, data, config);
    return await response.data;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}


export async function updateMenu(id, data) {
  try {
    const URLOrder = URL + "/MemuService/" + id;
    console.log(URLOrder);
    const response = await Axios.put(URLOrder, data, config);
    return await response.data;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}

export async function deleteMenu(id) {
  try {
    const URLOrder = URL + "/MemuService/" + id;
    console.log(URLOrder);
    const response = await Axios.delete(URLOrder, config);
    return await response.data;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
}